var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-dialog',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingData),expression:"loadingData"}],ref:"dialog",attrs:{"title":"Edit Goods","inputs-map":_vm.goodsInfo,"input-value-change":_vm.valueChange,"save-cb":_vm.saveGoodsInfo,"reset-inputs":_vm.resetGoodsInfo}})
}
var staticRenderFns = []

export { render, staticRenderFns }